import getMatrixType from "@secureo/common/utils/getMatrixType"
import { LockingSystemReducerState } from ".."

export const getMatrixFromComponents = (
	lockingComponentsUuids: LockingSystemReducerState["lockingComponentsUuids"],
	keyComponentsUuids: LockingSystemReducerState["keyComponentsUuids"],
	prevMatrix: LockingSystemReducerState["matrix"],
) => {
	const matrix: LockingSystemReducerState["matrix"] = []

	for (
		let lockingComponentIndex = 0;
		lockingComponentIndex < lockingComponentsUuids.length;
		lockingComponentIndex++
	) {
		const row: boolean[] = []
		const prevRow = prevMatrix?.[lockingComponentIndex] ?? []

		for (
			let keyComponentIndex = 0;
			keyComponentIndex < keyComponentsUuids.length;
			keyComponentIndex++
		) {
			const isSelected = prevRow?.[keyComponentIndex] ?? false
			row[keyComponentIndex] = isSelected
		}

		matrix.push(row)
	}

	return matrix
}

const getUpdatedMatrix = (
	lockingComponentsUuids: LockingSystemReducerState["lockingComponentsUuids"],
	keyComponentsUuids: LockingSystemReducerState["keyComponentsUuids"],
	prevMatrix: LockingSystemReducerState["matrix"] = [[]],
) => {
	const matrix: LockingSystemReducerState["matrix"] = getMatrixFromComponents(
		lockingComponentsUuids,
		keyComponentsUuids,
		prevMatrix,
	)
	const matrixType = getMatrixType(matrix)

	return {
		matrix,
		matrixType,
	}
}

export default getUpdatedMatrix
